/* eslint-disable no-console */
import {
  APP_ENVIRONMENT,
  NEW_RELIC_ACCOUNT_ID,
  NEW_RELIC_AGENT_ID,
  NEW_RELIC_APPLICATION_ID,
  NEW_RELIC_LICENSE_KEY,
  NEW_RELIC_TRUST_KEY,
  API_BACKEND_HOST,
  API_FEEDBACKS_HOST,
} from 'shared/config'

export const setupNewRelicAgent = () => {
  if (!['staging', 'prod'].includes(APP_ENVIRONMENT)) return null

  import('@newrelic/browser-agent/loaders/browser-agent')
    .then(({ BrowserAgent }) => {
      const options = {
        init: {
          session_replay: {
            enabled: true,
            block_selector: '',
            mask_text_selector: '*',
            sampling_rate: 10.0,
            error_sampling_rate: 100.0,
            mask_all_inputs: true,
            collect_fonts: true,
            inline_images: false,
            inline_stylesheet: true,
            fix_stylesheets: true,
            preload: false,
            mask_input_options: {},
          },
          distributed_tracing: {
            enabled: true,
            cors_use_newrelic_header: true,
            cors_use_tracecontext_headers: true,
            allowed_origins: [API_BACKEND_HOST, API_FEEDBACKS_HOST],
          },
          privacy: { cookies_enabled: true },
          ajax: { deny_list: ['bam.eu01.nr-data.net'] },
        },
        info: {
          beacon: 'bam.eu01.nr-data.net',
          errorBeacon: 'bam.eu01.nr-data.net',
          licenseKey: NEW_RELIC_LICENSE_KEY,
          applicationID: NEW_RELIC_APPLICATION_ID,
          sa: 1,
        },
        loader_config: {
          accountID: NEW_RELIC_ACCOUNT_ID,
          trustKey: NEW_RELIC_TRUST_KEY,
          agentID: NEW_RELIC_AGENT_ID,
          licenseKey: NEW_RELIC_LICENSE_KEY,
          applicationID: NEW_RELIC_APPLICATION_ID,
        },
      }

      new BrowserAgent(options)
      console.log('[New Relic]: success')
    })
    .catch((error) => console.error(`[New Relic]: `, error))
}
